import React from 'react';
import AppPageWrapper from '../../../AppLayout/AppPageWrapper';
import SettingsBillingPageHeader from './SettingsBillingPageHeader';

const SettingsBillingPageWrapper = props => {
    return <AppPageWrapper header={<SettingsBillingPageHeader />} {...props} />;
};

export default SettingsBillingPageWrapper;
